import snapshotActions from '../actions/SnapshotsActions';

export const defaultState = {};

export function addSnapshot(questionId, interactionId, time, content, state) {
    const interactions = state[questionId] || {};
    const snapshots = Object.assign({},
        interactions[interactionId] || {},
        { [time]: { content, interactionId, questionId, time } }
    );
    const question = Object.assign({}, interactions, { [interactionId]: snapshots });

    return Object.assign({}, state, { [questionId]: question });
}

export default function (state = defaultState, action) {
    switch (action.type) {
    case snapshotActions.types.SNAPSHOTS_ADD_SNAPSHOT:
        return addSnapshot(action.questionId, action.interactionId, action.time, action.content, state);
    default:
        return state;
    }
}
